import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {useUserStore} from '@/stores/userStore';
import {saveRoute} from '../guardHelper';
import DesklyConnectRepository from '../../api/repositories/DesklyConnectRepository';

export async function handleAuthorizeSensor(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const {isAuthenticated} = useUserStore();

    // Check if user is authenticated first
    if (!isAuthenticated) {
        saveRoute(to);
        return {name: 'Login'};
    }

    const sensorId = to.query.sensorId as string;

    if (!sensorId) {
        return {name: 'AuthorizeSensorFailed', query: {sensorId}};
    }

    try {
        const result = await DesklyConnectRepository().authorizeSensor(sensorId);

        if (result.success) {
            return;
        }
    } catch {
        // Error already handled by api.error (toast shown)
        // Redirect to failure page
        return {name: 'AuthorizeSensorFailed', query: {sensorId}};
    }

    // If we get here, something went wrong
    return {name: 'AuthorizeSensorFailed', query: {sensorId}};
}
